import { useState } from 'react';
import toast from 'react-hot-toast';
import Modal from '../components/Modal.jsx';
import { aiApi } from '../api/workspace.js';
import { apiError } from '../api/client.js';
import { useEditor } from './editorStore.js';

const SUGGESTIONS = [
  'A SaaS landing page for an AI meeting note-taker. Include hero, 3-up features, social proof, pricing, and CTA.',
  'A studio portfolio for a 2-person design agency. Hero, selected work in 2 columns, contact CTA.',
  'A pre-launch waitlist page for an online cohort course. Hero, what you’ll learn, instructor bio, CTA.',
];

export default function AiPromptModal({ open, onClose }) {
  const page = useEditor((s) => s.page);
  const replaceBlocks = useEditor((s) => s.replaceBlocks);
  const [prompt, setPrompt] = useState('');
  const [busy, setBusy] = useState(false);

  async function generate() {
    if (!page || !prompt.trim()) return;
    setBusy(true);
    try {
      const result = await aiApi.generatePage(page.id, prompt.trim());
      replaceBlocks(result.blocks || []);
      toast.success('Generated. Review and publish when ready.');
      onClose();
    } catch (err) {
      const msg = apiError(err);
      if (msg.toLowerCase().includes('api key')) {
        toast.error('Add an API key in Settings first.');
      } else {
        toast.error(msg);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Generate page with AI"
      wide
      footer={
        <>
          <button onClick={onClose} className="btn-ghost">Cancel</button>
          <button onClick={generate} className="btn-primary" disabled={busy || !prompt.trim()}>
            {busy ? 'Generating…' : 'Replace draft with generated page'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-ink-500">
          Describe the page you want. The model returns a block tree that replaces the current
          draft. (Configure your provider key in Settings → AI provider.)
        </p>
        <textarea
          className="input min-h-[140px]"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g. A landing page for an indie SaaS that helps freelancers track invoices…"
          autoFocus
        />
        <div>
          <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-ink-500">
            Try one
          </div>
          <div className="flex flex-wrap gap-2">
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                onClick={() => setPrompt(s)}
                className="rounded-full border border-ink-200 bg-white px-3 py-1 text-xs text-ink-600 hover:border-brand-400 hover:text-brand-700 dark:border-ink-800 dark:bg-ink-900 dark:text-ink-300"
              >
                {s.slice(0, 60)}…
              </button>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
